import VueRouter, { Route } from 'vue-router';
import { Store } from 'vuex';
import { RootState } from 'frontend/types';

/**
 * Pages after signing up via a marketing/sponsor landing page use the mlp=true GET param to
 * trigger special behavior
 */
export const MARKETING_LANDING_PAGES_GET_PARAM = 'mlp';

export function justSignedUpFromMarketingLandingPage(route: Route): boolean {
  return route.query[MARKETING_LANDING_PAGES_GET_PARAM] === 'true';
}

export async function handleClosedNuxPaywallFromMarketingPage(
  store: Store<RootState>,
  router: VueRouter,
) {
  await router.push({ name: 'nux_welcome' });
  // Need to clear plans here so we don't re-show the paywall during the normal NUX flow
  store.dispatch('paywall/clearPlans');
}
